import { Navigate, Outlet } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { usePrivyAccount } from '@/hooks';
import useFundedAccount from '@/hooks/use-funded-account';

import { PageSkeleton } from '../ui';

export default function DepositLayout() {
  const { isFundedOrEval } = useFundedAccount();
  const { isConnected, isEmbedded, isReady } = usePrivyAccount();
  if (!isReady) return <PageSkeleton />;
  if (!isConnected || !isEmbedded || isFundedOrEval)
    return <Navigate to={ROUTES.TRADE} />;
  return <Outlet />;
}
